import type { OptionKV } from "~styled/selector/Selector";

export enum EFormaPago {
  DebitoConTarjetaCredito = "DebitoConTarjetaCredito",
  DebitoConCBU = "DebitoConCBU",
  CuponPago = "CuponPago",
  Directo = "Directo",
}

const TODOS = "";
export const DEBITOTC = EFormaPago.DebitoConTarjetaCredito;
export const DEBITOCBU = EFormaPago.DebitoConCBU;
export const CUPONPAGO = EFormaPago.CuponPago;
export const DIRECTO = EFormaPago.Directo;

const formasPagoOptions: Record<EFormaPago | typeof TODOS, string> = {
  [TODOS]: "Todas",
  [DEBITOTC]: "Débito con Tarjeta de Crédito",
  [DEBITOCBU]: "Débito con CBU",
  [CUPONPAGO]: "Cupón de pago",
  [DIRECTO]: "Directo",
};

const formasPago: EFormaPago[] = [DEBITOTC, DEBITOCBU, CUPONPAGO, DIRECTO];

const formasPagoFilter: OptionKV<EFormaPago | typeof TODOS>[] = [
  { label: formasPagoOptions[TODOS], value: TODOS },
  { label: formasPagoOptions[DEBITOTC], value: DEBITOTC },
  { label: formasPagoOptions[DEBITOCBU], value: DEBITOCBU },
  { label: formasPagoOptions[CUPONPAGO], value: CUPONPAGO },
  { label: formasPagoOptions[DIRECTO], value: DIRECTO },
];

const formasPagoEndoso: OptionKV<EFormaPago>[] = [
  { label: formasPagoOptions[DEBITOTC], value: DEBITOTC },
  { label: formasPagoOptions[DEBITOCBU], value: DEBITOCBU },
  { label: formasPagoOptions[CUPONPAGO], value: CUPONPAGO },
  //{ label: formasPagoOptions[DIRECTO], value: DIRECTO }
];

export { formasPagoOptions, formasPago, formasPagoFilter, formasPagoEndoso };
